import { playerEventsStorage, playerStorage } from '../../storages';

export function seamlessTransitionCleanup() {
  playerEventsStorage.clearIsSeamlessTransitionEventFired();
  playerEventsStorage.clearIsSeamlessPrefetchEventFired();
  playerStorage.clearSeamlessMediaEntryData();
}
